<template>
  <div class="stats">
    <h1 class="stats__title">
      Les performances des sites
    </h1>

    <div class="stats__cards">
      <div class="stat-card stats__card">
        <h4>
          Nombre de sites actifs
        </h4>
        <p class="stats__card__data">
          {{ statsSites }}
        </p>
        <p class="text text--hint">En date du {{ currentDate }}</p>
      </div>
      <div class="stat-card stats__card">
        <h4>
          Nombre de comptes créés
        </h4>
        <p class="stats__card__data">
          {{ statsUsers }}
        </p>
        <p class="text text--hint">En date du {{ currentDate }}</p>
      </div>
      <div class="stat-card stats__card">
        <h4>
          Nombre de vues
        </h4>
        <p class="stats__card__data">
          {{ Math.round(statsVisits) }}
        </p>
        <p class="text text--hint">
          En moyenne par site
        </p>
      </div>
      <div class="stat-card stats__card">
        <h4>
          Nombre de messages
        </h4>
        <p class="stats__card__data">
          {{ statsMessages }}
        </p>
        <p class="text text--hint">
          En moyenne par site
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      statsSites: 'stats/getSites',
      statsUsers: 'stats/getUsers',
      statsVisits: 'stats/getVisits',
      statsMessages: 'stats/getMessages',
    }),

    currentDate() {
      return new Date().toLocaleDateString('fr-FR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });
    },
  },
};
</script>
